import { render, staticRenderFns } from "./symbol-pair-status.component.vue?vue&type=template&id=00306148"
import script from "./symbol-pair-status.component.vue?vue&type=script&lang=js"
export * from "./symbol-pair-status.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports